"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = delay;

// delay middleware
// @author Pluto <huarse@gmail.com>
// @create 2020/01/08 08:41

/**
 * send request delay
 */
async function delay(ctx) {
  await new Promise(r => {
    if (!ctx.meta.delay) r();else setTimeout(r, ctx.meta.delay);
  });
  await ctx.next();
}